import {EScene} from '@/types/scene.types'
import AudioManager from '@repo/shared/AudioManager'
import {debugLogger} from '@repo/shared/utils/debugLogger'
import {useSetAtom} from 'jotai'
import {RESET} from 'jotai/utils'
import {useInitContext} from '../InitProvider/InitProvider'
import {
  activeSlotsState,
  endPositonsState,
  gameCodeState,
  gameEndedState,
  gameModeState,
  gameStartedState,
  sceneState,
  singlePlayerDataState,
  singlePlayerResultState,
  storeWinnersDataState,
  timestampGameEndedState,
  timestampGameStartedState,
  timestampSlot1FinishState,
  timestampSlot2FinishState,
  timestampSlot3FinishState,
  timestampSlot4FinishState,
  timestampSlot5FinishState,
  totalPlayersState,
} from '../Store/atoms'
import FrameStore from '../Store/FrameStore'

const fStore = new FrameStore()
const audioManager = new AudioManager()

export const useReset = () => {
  const {resetInit} = useInitContext()

  const setEndPositions = useSetAtom(endPositonsState)
  const setGameCode = useSetAtom(gameCodeState)
  const setGameMode = useSetAtom(gameModeState)
  const setGameStarted = useSetAtom(gameStartedState)
  const setGameEnded = useSetAtom(gameEndedState)
  const setScene = useSetAtom(sceneState)
  const setSinglePlayerData = useSetAtom(singlePlayerDataState)
  const setSinglePlayerResult = useSetAtom(singlePlayerResultState)
  const setTimestampGameStarted = useSetAtom(timestampGameStartedState)
  const setTimestampGameEnded = useSetAtom(timestampGameEndedState)
  const setTimestampSlot1Finish = useSetAtom(timestampSlot1FinishState)
  const setTimestampSlot2Finish = useSetAtom(timestampSlot2FinishState)
  const setTimestampSlot3Finish = useSetAtom(timestampSlot3FinishState)
  const setTimestampSlot4Finish = useSetAtom(timestampSlot4FinishState)
  const setTimestampSlot5Finish = useSetAtom(timestampSlot5FinishState)
  const setActiveSlots = useSetAtom(activeSlotsState)
  const setTotalPlayers = useSetAtom(totalPlayersState)
  const setStoreWinnersData = useSetAtom(storeWinnersDataState)

  const resetAll = () => {
    debugLogger({
      message: 'resetAll',
      tag: 'useReset',
    })

    // Reset FrameStore
    fStore.reset()

    // Reset audioManager
    audioManager.reset()

    // Reset all atoms
    setEndPositions(RESET)
    setGameCode(RESET)
    setGameStarted(RESET)
    setGameEnded(RESET)
    setGameMode(RESET)
    setSinglePlayerData(RESET)
    setSinglePlayerResult(RESET)
    setTimestampGameStarted(RESET)
    setTimestampGameEnded(RESET)
    setTimestampSlot1Finish(RESET)
    setTimestampSlot2Finish(RESET)
    setTimestampSlot3Finish(RESET)
    setTimestampSlot4Finish(RESET)
    setTimestampSlot5Finish(RESET)
    setTotalPlayers(RESET)
    setActiveSlots(RESET)
    setStoreWinnersData(RESET)
    setScene(EScene.PRE_LOBBY)

    // Reset Init context
    resetInit()
  }

  return {
    resetAll,
  }
}
